import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import decBottom from '../../assets/images/dec_bottom_license.svg';
import decUp from '../../assets/images/dec_up_license.svg';
import stateName from '../../assets/images/losSantos.svg';

const StyledContainer = styled.div`
	padding: 20px;
`;

const StyledHead = styled.div`
	display: flex;
	gap: 10px;

	img {
		width: 40px;
		height: 40px;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledHeadText = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;
`;

const StyledStateName = styled.div`
	width: 124px;
	height: 15px;
	mask-image: url(${stateName});
	mask-size: contain;
	mask-repeat: no-repeat;
	mask-position: center;
	-webkit-mask-image: url(${stateName});
	-webkit-mask-size: contain;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-position: center;
	background-color: #253289;
	margin: 4.5px 0;
`;

const StyledDividers = styled.div`
	margin: 14px 0;
`;

const StyledMainContainer = styled.div`
	position: relative;
	display: grid;
	grid-template-columns: 150px 1fr;
	gap: 30px;

	& > img {
		width: 150px;
		height: 170px;
		user-select: none;
		pointer-events: none;
		border-radius: 10px;
	}
`;

const StyledDecUp = styled.div`
	position: absolute;
	top: 0;
	left: 120px;
	width: 52px;
	height: 170px;
	background-image: url(${decUp});
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center;
`;

const StyledRightContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding-right: 10px;
`;

const StyledInfoTop = styled.div`
	display: flex;
	justify-content: space-between;
`;

const StyledValue = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;

	${Text} {
		&:first-child {
			font-size: 12px;
			color: #000000;
			opacity: 0.5;
		}

		&:last-child {
			font-weight: 500;
			font-size: 14px;
			color: #253289;
		}
	}
`;

const StyledInfoBottom = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;

	& > ${Text} {
		font-size: 12px;
		color: #000000;
		opacity: 0.5;
	}
`;

const StyledCategoriesGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 10px;
`;

const StyledDecBottom = styled.div`
	width: 460px;
	height: 24px;
	background-image: url(${decBottom});
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center;
	margin-top: 3px;
`;

export {
	StyledCategoriesGrid,
	StyledContainer,
	StyledDecBottom,
	StyledDecUp,
	StyledDividers,
	StyledHead,
	StyledHeadText,
	StyledInfoBottom,
	StyledInfoTop,
	StyledMainContainer,
	StyledRightContainer,
	StyledStateName,
	StyledValue,
};
